import { createStore } from 'vuex'
import websocket from './modules/websocket';

export default createStore({
    modules: {
      websocket, // Registra o módulo
    },
    state () {
      return {
        usuario: null,
        //listaSistemas: null,
      }
    },
    mutations: {
        setUser(state, usuario) {
            state.usuario = usuario;
        },
        // Backend respondeu 402 (licença vencida durante a sessão): faz o AppLayout exibir o BloqueioLicenca
        limparLicencas(state) {
            if (state.usuario) state.usuario.licencas = [];
        },
        // setSistemas(state, listaSistemas) {
        //     state.listaSistemas = listaSistemas;
        // },
    },   
  })
